export default "__VITE_ASSET__BceohbYD__"